function QuirideMap (){
    return(
        <section className="container">
            <div className="map_content">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d2513740.631144983!2d119.05339414943829!3d9.888391729852628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sph!4v1740186746227!5m2!1sen!2sph" width="800" height="450" style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </section>
    );
}

export default QuirideMap;